module.exports = __webpack_public_path__ + "static/media/report.fa2bf624.png";